var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.5 10.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H1.25a.75.75 0 0 1-.75-.75Zm14.188 2.625a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM12.062 14a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Zm-6.749-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25ZM2.688 14a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.438 14a.75.75 0 0 1 .75-.75h5.625a.75.75 0 0 1 0 1.5H7.186a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 4.75v8.5h1.438a.75.75 0 0 1 0 1.5H1.875A1.375 1.375 0 0 1 .5 13.375v-8.75A1.375 1.375 0 0 1 1.875 3.25H13.75a.75.75 0 0 1 .75.75v8.375a.75.75 0 0 1-1.5 0V4.75H2Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 8.375a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v5a1.375 1.375 0 0 1-1.375 1.375h-1.563a.75.75 0 0 1 0-1.5H18V9.125h-4.25a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16.992 6 1.062 2.654a.75.75 0 1 0 1.392-.558l-1.093-2.733a1.366 1.366 0 0 0-1.277-.863H14.5V6h2.492l.084-1.5-.084 1.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgTruck;